var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom-content"},[_c('a-button',{attrs:{"type":"primary","disabled":_vm.proSource!=0,"loading":_vm.submitLoading},on:{"click":_vm.proPublish}},[_vm._v("发布并上架")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }